/** Underscores and dashes to spaces for display. Null / undefined give "". */
export function sanitize(str: string | null | undefined): string {
  if (typeof str !== "string") return "";
  return str.replace(/[-_]/g, " ");
}

/** Display label for an item status. Null / undefined (no status yet) give "". */
export function sanitizeItemStatusLabel(status: string | null | undefined): string {
  if (typeof status !== "string") return "";
  const statusMap: Record<string, string> = {
    "on_site": "On Site",
    "in_stock": "In Stock",
    "in_delivery": "In Delivery",
    "in_retrieval": "In Retrieval",
    "in_maintenance": "In Maintenance",
    "missing": "Missing",
    "incomplete": "Incomplete",
    "in_stock_main": "In Stock (Main)",
    "in_transit_to_sub": "In Transit (to Sub)",
    "inbound_sub": "Inbound (Sub)",
    "in_stock_sub": "In Stock (Sub)",
    "issued_to_field": "Issued (to Field)",
    "delivered": "Delivered",
    "storm_stock": "Storm Stock",
  };

  return statusMap[status.toLowerCase()] || status;
}

export function isValidEmail(email: string): boolean {
  return /^\S+@\S+\.\S+$/.test(email);
}
